module.exports = __webpack_public_path__ + "static/media/lighting.ddcd0e2c.svg";